// eslint-disable-next-line
export const commuteOptions = [
  { value: 0, label: '0 - 5 miles' },
  { value: 1, label: '5 - 10 miles' },
  { value: 2, label: '10 - 20 miles' },
  { value: 3, label: '20 - 30 miles' },
  { value: 4, label: '30+ miles' },
];
